import React from 'react';
import PropTypes from 'prop-types';

import InfoIcon from '@mui/icons-material/Info';
import RestoreIcon from '@mui/icons-material/Restore';
import { Tooltip } from '@mui/material';

import IconError from '../IconError';

import common from './formElementStyles/commonFormElements.module.css';
import radio from './formElementStyles/radioButtons.module.css';

const RadioButtons = ({
    id,
    label = '',
    onChange,
    radioButtons = [
        { id: 'No', label: 'No', onChangeVal: false },
        { id: 'Yes', label: 'Yes', onChangeVal: true }
    ],
    disabled = false,
    mandatory = false,
    value,
    error = {},
    customClass = '',
    onSearchAuditItems,
    isAuditable = false,
    tooltipMessage
}) => {
    return (
        <div
            className={`${common.fieldWrapper} ${radio.radioButtonWrapper} ${customClass ? radio[customClass] : ''}`}>
            <fieldset id={id} data-testid={`fieldset_${id}`}>
                <legend>
                    {label} {mandatory && <sup>*</sup>}
                    {isAuditable && (
                        <div>
                            <RestoreIcon onClick={() => onSearchAuditItems(label)} />
                        </div>
                    )}
                </legend>

                {radioButtons.map((el) => {
                    const uniqueId = `${id}_${el.id}`;
                    return (
                        <div key={el.id} className={radio.buttonGroupEl}>
                            <input
                                id={uniqueId}
                                data-testid={`radio_button_${el.id}`}
                                type="radio"
                                name={id}
                                value={el.id}
                                checked={el.onChangeVal === value || el.id === value}
                                disabled={el?.buttonDisabled || disabled || false}
                                onChange={() => onChange(el.onChangeVal)}
                            />
                            <label htmlFor={uniqueId}>{el.label}</label>
                        </div>
                    );
                })}

                {tooltipMessage && (
                    <Tooltip title={tooltipMessage} placement="top" className={radio.tooltip}>
                        <InfoIcon />
                    </Tooltip>
                )}
            </fieldset>
            {error?.error && (
                <div>
                    <IconError text={error} />
                </div>
            )}
        </div>
    );
};

RadioButtons.propTypes = {
    id: PropTypes.string,
    label: PropTypes.string,
    disabled: PropTypes.bool,
    mandatory: PropTypes.bool,
    radioButtons: PropTypes.arrayOf(PropTypes.object),
    value: PropTypes.any,
    onChange: PropTypes.func,
    error: PropTypes.object,
    customClass: PropTypes.string,
    onSearchAuditItems: PropTypes.func,
    isAuditable: PropTypes.bool,
    tooltipMessage: PropTypes.string
};

export default RadioButtons;
